import type { paths } from "../../__definitions__/slack-engine-v2.changeengine.com-definitions";
import type { Workers } from "../../utils/service-url";
import type { ApiResponse } from "./client";
import { WorkerApiService } from "./worker";

export type SlackEngineV2BuildMessageRequest =
  paths["/build-message"]["post"]["requestBody"]["content"]["application/json"];

export type SlackEngineV2Message =
  paths["/build-message"]["post"]["responses"]["200"]["content"]["application/json"];

export class SlackEngineSevice extends WorkerApiService {
  module = "slack-engine-v2" as const satisfies Workers;

  async buildMessage(
    body: SlackEngineV2BuildMessageRequest,
  ): Promise<ApiResponse<SlackEngineV2Message>> {
    return await this.post("build-message", { ...body });
  }
}
